{
  "adobeExperienceCloudNoOrgsSelect": "Seleccione otra cuenta de organización",
  "help": "Ayuda",
  "newAnnouncement": "Tiene un nuevo anuncio",
  "notification": "Notificaciones y anuncios",
  "profile": "Perfil",
  "searchButton": "Buscar",
  "sidenavMenuCloseTooltip": "Cerrar el menú",
  "sidenavMenuOpenTooltip": "Abrir el menú",
  "solutionSwitcher": "Cambiar a otra solución",
  "unread": "notificaciones no leídas"
}
